module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.desktopNotifications.widget":[{"value":"DesktopNotifications","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/root/desktopNotifications.js
// module id = 216
// module chunks = 2